<template>
  <div class="c-app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-4">
          <div class="p-4">
            <form>
              <div class="text-center">
                <img
                  class="mb-4 rounded-circle"
                  src="/img/logo.jpg"
                  alt=""
                  height="72"
                />
                <p class="text-muted small">
                  <b>ScanCom Portal</b>
                </p>
                <h4>Reset password</h4>
              </div>

              <label for="">New password</label>
              <input
                placeholder="New Password"
                type="password"
                v-model="model.newPassword"
                :disabled="locked"
                :class="{
                  'has-error': submitting && invalid,
                  'form-control mt-2': true,
                }"
              />
              <label for="">Confirm new password</label>
              <input
                placeholder="Confirm Password"
                type="password"
                v-model="model.confirmPassword"
                :disabled="locked"
                :class="{
                  'has-error': submitting && invalid,
                  'form-control mt-2': true,
                }"
              />

              <div class="row mt-2">
                <div class="col-12">
                  <div class="text-center" v-if="loading">
                    <div class="spinner-border text-info" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                  <button
                    type="button"
                    class="btn btn-sm btn-primary w-100"
                    v-else
                    @click="reset"
                    :disabled="locked"
                  >
                    Reset password
                  </button>
                  <router-link class="returnLogin" :to="{ name: 'Login' }">
                    Return to login page
                  </router-link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ResetPassword",
  data() {
    return {
      model: {
        confirmPassword: "",
        newPassword: "",
      },
      loading: false,
      submitting: false,
      message: "",
      locked: false,
    };
  },
  computed: {
    invalid() {
      return this.model.confirmPassword === "" || this.model.newPassword === "";
    },
    matchPassword() {
      return this.model.confirmPassword === this.model.newPassword;
    },
  },
  async mounted() {
    document.title = "ScanCom Portal";
    let req = JSON.parse(localStorage.userAccount);
    const resp = await this.$http
      .post("/api/auth/confirm", req)
      .catch((err) => {
        this.$swal({
          icon: "error",
          text: err,
        });
      });

    if (resp.data.status === "Error") {
      this.$router.push({ name: "Login" });
    }
  },
  methods: {
    async reset() {
      this.submitting = true;
      this.locked = true;

      if (this.invalid) {
        this.$swal({
          icon: "error",
          text: "New password and confirm password is not empty",
        });
        this.locked = false;
        return;
      }

      if (!this.matchPassword) {
        this.$swal({
          icon: "error",
          text: " New password  and confirm password is not match",
        });
        this.locked = false;
        return;
      }

      let req = JSON.parse(localStorage.userAccount);
      const resp = await this.$http
        .post("/api/auth/reset", {
          userName: req.email,
          password: this.model.newPassword,
        })
        .catch((err) => {
          this.$swal({
            icon: "error",
            text: err,
          });
        });

      if (resp.data.status === this.$const.RESPONSE_TYPES.Success) {
        localStorage.userAccount = "";
        this.$swal({
          icon: "success",
          text: "Password has changed successfully",
          buttons: {
            cancel: "OK",
            catch: {
              text: "Password changed",
              value: "changed",
            },
            defeat: true,
          },
        }).then((value) => {
          this.$router.push({ name: "Login" });
        });
      } else {
        this.$swal({
          icon: "error",
          text: "Password can not changed",
        });
      }

      this.loading = false;
      this.submitting = false;
      this.locked = false;
    },
  },
};
</script>

<style scoped>
.has-error {
  border: 1px solid #d33c40;
}
.error-message {
  color: #d33c40;
}
.success-message {
  color: #32a95d;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>

<style lang="scss" scoped>
.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;

  .form-signin .form-control {
    position: relative;
    box-sizing: border-box;
    height: auto;
    padding: 10px;
    font-size: 16px;
  }

  input[type="email"] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  input[type="password"] {
    margin-bottom: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
}

.btn-block {
  display: block;
  width: 100%;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  -webkit-clip-path: inset(50%);
  clip-path: inset(50%);
  border: 0;
}

body {
  background-color: #f5f5f5;
}
</style>
